import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import { setupAxiosInterceptors } from './utils/toastHelper';
import GlobalToast from './components/common/GlobalToast';
import './config/api'; // Import API configuration

// Setup axios interceptors for automatic toasts
setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalToast />
    <App />
  </React.StrictMode>
);